import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export async function patchPermissionsOfUsers(projectId, userPermissions) {
  const apiPath = `permission/project/${projectId}/user-permissions/update-user-permissions`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: userPermissions,
  });
  const response = await axios(signedRequest);

  return response.data;
}
